<script>
import appConfig from "@/app.config.json";
import Layout from "@/views/layouts/main.vue";
import apiEndpoints from "@/services/apiEndpoints";
import sweetAlert from "@/mixins/sweetAlert";
import DatePicker from "vue2-datepicker";
import DailyReportControlRules from "@/services/DailyReportControlRules";
import dailyReportControlRules from "@/mixins/dailyReportControlRules";
import WastesAfterTreatment from "@/views/pages/daily_reports/modals/Wastes.vue";
import WasteInput from "@/views/pages/daily_reports/components/sp/waste_input.vue";
import ServiceInput from "@/views/pages/daily_reports/components/sp/service_input.vue";
import CarInput from "@/views/pages/daily_reports/components/sp/car_input.vue";
import routerRedirectly from "@/mixins/daily_reports/routerRedirectly";
import scrollToError from "@/mixins/scrollToError";

export default {
  name: "daily_reports.input",
  page: {
    title: "作業日報入力",
    meta: [{name: "description", content: appConfig.description}]
  },
  mixins: [sweetAlert, dailyReportControlRules, routerRedirectly,scrollToError],
  components: {
    Layout,
    DatePicker,
    WasteInput,
    ServiceInput,
    WastesAfterTreatment,
    CarInput
  },
  data() {
    return {
      dailyReport: {},
      vendorSite: {},
      wastesOrServicesByDailyReport: [],
      currentWasteOrService: {},
      isLoading: false,
      errors: {},
      factoryName: '',
      disableCompleteFields: false,
      controlRules: null,
      disableCancelFields: false,
      transportCompletedText: '運搬',
      treatmentAcceptedText: '搬入',
      treatmentCompletedText: '処分',
      currentIndex: 0
    }
  },
  created() {
    if (!this.isInputPage) {
      return this.backByInputPage();
    }

    this.getData();
  },
  methods: {
    getControlRules(workOrderType, zzOwn, vendorSiteSelect) {
      const ruleControl = new DailyReportControlRules();
      this.controlRules = ruleControl.getAllControlRules(workOrderType, zzOwn, vendorSiteSelect);
    },
    async getData() {
      this.isLoading = true;

      const url = apiEndpoints.detail_daily_report_with_wastes_or_services(this.dailyReportId, this.vendorSiteId);
      const {status, data, code} = await this.$http.getWithLoading(url, {
        vendor_site_id: this.vendorSiteId,
        waste_or_service_ids: this.wasteOrServiceIds,
      });

      this.isLoading = false;

      if (status) {
        let workOrderType = data?.result?.daily_report?.work_order_json?.zz_work_order_type_id;
        if (workOrderType === this.$constant.work_order_type.transshipment_storage) {
          workOrderType = workOrderType + '_' + data?.result?.daily_report?.schedule?.transport_and_hold_section;
        }
        let zzOwnId = data?.result?.daily_report?.schedule?.vendor?.zz_own_id;
        if ([this.$constant.work_order_type.work, this.$constant.work_order_type.others].includes(workOrderType)) {
          zzOwnId = null;
        }
        this.getControlRules(workOrderType, zzOwnId, !!this.vendorSiteId);
        if (this.isInputPage) {
          return this.mappingDataInputPage(data.result);
        }

        return
      }

      this.$router.go(-1)
    },
    mappingDataInputPage(data) {
      this.dailyReport = data.daily_report;
      this.wastesOrServicesByDailyReport = data.daily_report.wastes_or_services_by_daily_report.map((x, index) => {
        x.origin_index = index;
        let waste_or_service_by_work_order = this.getTargetWasteOrServiceFromJson(x.wastes_or_services_by_work_order_id);
        if (waste_or_service_by_work_order?.service_id) {
          x.service_id = waste_or_service_by_work_order?.service_id;
        }

        if (!x.car_selected && this.carOptions.length) {
          x.car_selected = this.carOptions[0].id;
        }

        return x;
      });
      this.vendorSite = data.vendor_site;

      delete this.dailyReport.wastes_or_services_by_daily_report;
    },
    getFactoryName(vendor) {
      this.factoryName = vendor.name_abbreviated || '';
    },
    setValueCompleteFields(is_schedule_canceled) {
      if (is_schedule_canceled) {
        this.dailyReport[`is_treatment_accepted_${this.zzVendorSiteIndex}`] = false;
        this.dailyReport[`is_treatment_completed_${this.zzVendorSiteIndex}`] = false;
        this.dailyReport.is_transport_completed = false;
      }
      this.disableCompleteFields = !!is_schedule_canceled;
    },
    onOpenModalSelectWaste(wasteOrService) {
      this.$refs.wastesAfterTreatmentModal.openModal(wasteOrService.wastes_after_treatment_by_daily_report.map(x => x.id), 
            this.getTargetWasteOrServiceFromJson(wasteOrService.wastes_or_services_by_work_order_id) // jsonのwosBywoを直接送る  
      );
      this.currentWasteOrService = wasteOrService;
    },
    onSelectedWastes(data) {
      if (!this.currentWasteOrService.id) return;

      const index = this.wastesOrServicesByDailyReport.findIndex(x => x.id === this.currentWasteOrService.id);
      if (index === -1) return;

      this.wastesOrServicesByDailyReport[index].wastes_after_treatment_by_daily_report = data;
    },
    onModalWastesAfterTreatmentHidden() {
      this.resetCurrentWasteOrService();
    },
    resetCurrentWasteOrService() {
      this.currentWasteOrService = null;
    },
    backByInputPage() {
      this.backToDailyReport()
    },
    async submitInput(fromDelete = false, isTemp = false) {
      this.errors = {};

      let params = this.prepareParams();
      params.isTemp = isTemp;
      params.isApprove = false;

      // 一時保存でも工場日報の場合、「処分終了年月日が入力されていない場合処分完了フラグを倒す」はやったほうがいい。
      // 日付が入っていないのに完了のままだとそのまま承認できてしまうロジックのため。
      // 立てるのは逆にやっちゃダメ
      if (params.wastes_or_services_by_daily_report && params.wastes_or_services_by_daily_report.length > 0) {
        if(this.vendorSite && this.zzVendorSiteIndex){
          params.wastes_or_services_by_daily_report.map(
            function(item){ 
              if(item.treatment_completed_date != null){
              }else{
                item.treatment_complete = 0;
              }
            }
          );
        }
      }

      const url = apiEndpoints.input_daily_report(this.dailyReportId, this.vendorSiteId);

      const {status, data, code} = await this.$http.post(url, params);

      // 削除時の更新の場合ここで処理を中断する
      if(fromDelete){
        return {status: status, data: data, code: code};
      }

      if (status) {
        this.successToast("修正が成功しました。", false, 2000);
        if (this.isInputPage) {
          return this.backByInputPage();
        }
      }

      if (this.$helpers.isDisplayFormError(code)) {
        this.errors = data.errors;
      } else if (this.$helpers.isDisplayErrorInLocalComponent(code)) {
        if (data.approved_input) {
          return this.alertApprovedWastesOrServices(data.message)
        }
        return this.errorToast(data.message);
      }
    },
    prepareParams() {
      const dailyReportClone = this.$_.cloneDeep(this.dailyReport);
      delete dailyReportClone.work_order_json;
      delete dailyReportClone.schedule;
      const wastesOrServicesByDailyReportClone = this.$_.cloneDeep(this.wastesOrServicesByDailyReport);
      wastesOrServicesByDailyReportClone.forEach(item => {
        item.wastes_after_treatment_by_daily_report.forEach(wasteAfterTreatment => {
          delete wasteAfterTreatment.pivot;
        });
        item.estimates_by_daily_report.forEach(estimate => {
          delete estimate.pivot
          delete estimate.zz_unit
          delete estimate.waste
        });
      });

      return {
        daily_report: dailyReportClone,
        wastes_or_services_by_daily_report: wastesOrServicesByDailyReportClone,
        cars_by_daily_report: this.carsByWorkOrder,
      };
    },
    alertApprovedWastesOrServices(message) {
      this.confirm(
        '',
        '',
        message,
        "warning", "OK", "", false
      ).then(async (result) => {
        window.location.reload();
      });
    },
    nextWaste() {
      if (this.currentIndex >= this.wastesOrServicesByDailyReportSort.length) {

        this.currentIndex = 0;
      }

      this.currentIndex++;
    },
    previousWaste() {
      (this.currentIndex > 0) && this.currentIndex--;
    },
    /**
     * キャンセル/キャンセル解除確認ダイアログ表示
     */
     onClickScheduleCanceled() {
      let cfMessage = "";
      let successMessage = "";
      let buttonType = "cencel";
      if(this.dailyReport.is_schedule_canceled){
        cfMessage = "キャンセルを解除します。よろしいですか。";
        successMessage = "キャンセルを解除しました。";
      }else{
        cfMessage = "キャンセルとして登録します。よろしいですか。";
        successMessage = "キャンセルとして登録しました。";
      }
      this.confirm(
        '',
        '',
        cfMessage,
        'info',
        'はい',
        'いいえ',
      ).then(async (result) => {
        if (result.isConfirmed) {
          await this.submitCancelCompleted(successMessage, buttonType);
        }
      });
    },
    /**
     * 「運搬完了」クリック時の確認ダイアログ表示
     */
     onClickTransportCompleted() {
      let cfMessage = "運搬完了として登録します。よろしいですか。";
      let successMessage = "運搬完了として登録しました。";
      let buttonType = "transport";
      this.confirm(
        '',
        '',
        cfMessage,
        'info',
        'はい',
        'いいえ',
      ).then(async (result) => {
        if (result.isConfirmed) {
          await this.submitCancelCompleted(successMessage,buttonType);
        }
      });
    },
    /**
     * 搬入完了確認ダイアログ表示処理
     * @param index 
     */
     onClickTreatmentAccepted(index) {
      let cfMessage = "搬入完了として登録します。よろしいですか。";
      let successMessage = "搬入完了として登録しました。";
      let buttonType = "treatmentAccepted";
      this.confirm(
        '',
        '',
        cfMessage,
        'info',
        'はい',
        'いいえ',
      ).then(async (result) => {
        if (result.isConfirmed) {
          await this.submitCancelCompleted(successMessage,buttonType, index);
        }
      });
    },
    onClickTreatmentCompleted(index, zzWorkOrderTypeId) {
      if(zzWorkOrderTypeId == '05' || zzWorkOrderTypeId == '06'){
        var cfMessage = "搬出完了として登録します。よろしいですか。";
        var successMessage = "搬出完了として登録しました。";
      }else if(zzWorkOrderTypeId == this.$constant.work_order_type.transportation_disposal){
        var cfMessage = "搬入・処分完了として登録します。よろしいですか。<br>（処分終了年月日が入力されている廃棄物のみ処分完了扱いとなります）";
        var successMessage = "搬入・処分完了として登録しました。";
      }else{
        var cfMessage = "処分完了として登録します。よろしいですか。<br>（処分終了年月日が入力されている廃棄物のみ処分完了扱いとなります）";
        var successMessage = "処分完了として登録しました。";
      }
      let buttonType = "treatment";
      this.confirm(
        '',
        '',
        cfMessage,
        'info',
        'はい',
        'いいえ',
      ).then(async (result) => {
        if (result.isConfirmed) {
          await this.submitCancelCompleted(successMessage,buttonType, index);
        }
      });
    },
    /**
     * 「キャンセル」「完了」確認ダイアログ「はい」の汎用処理
     * @param successMessage string 処理成功時トーストメッセージ
     */
     async submitCancelCompleted(successMessage, buttonType, index = 0) {
      this.errors = {};
      let params = this.prepareParams();
      params.buttonType = buttonType;
      params.ieTemp = false;
      params.isApprove = false;
      let workOrderType = this.dailyReport.work_order_json.zz_work_order_type_id; // 作業分類

      // 完了フラグの設定をcloneした後に行うことで戻し作業を不要にする
      switch(buttonType){
        case "cencel":
          params.daily_report.is_schedule_canceled = !this.dailyReport.is_schedule_canceled;
          break;
        case "transport":
          params.daily_report.is_transport_completed = 1;
          break;
        case "treatmentAccepted":
          params.daily_report[`is_treatment_accepted_${index}`] = 1;
          break;
        case "treatment":
          // 処分完了の時強制的に搬入も完了にする
          // →搬入完了にするのは作業分類処分の場合のみ
          // ↑搬入・処分同時の場合こうする必要があるので
          if(workOrderType == this.$constant.work_order_type.disposal){
            params.daily_report[`is_treatment_accepted_${index}`] = 1;
          }
          // 「搬出」および「積保（の工場）」の場合、処分ではないので日報の完了フラグをそのまま立てる
          if(workOrderType == this.$constant.work_order_type.discharge
            || workOrderType == this.$constant.work_order_type.transshipment_storage
          ){
            params.daily_report[`is_treatment_completed_${index}`] = 1;
          }{
            // それ以外の「処分完了」の場合、wastesOrServicesのtreatment_completeを設定する
            params.wastes_or_services_by_daily_report.map(
              function(item){ 
                if(item.treatment_completed_date != null){
                  item.treatment_complete = 1;
                }else{
                  item.treatment_complete = 0;
                }
              }
            );
          }
          break;
      }

      const url = apiEndpoints.input_daily_report(this.dailyReportId, this.vendorSiteId);

      const {status, data, code} = await this.$http.post(url, params);

      if (status) {
        this.successToast(successMessage, false, 2000);
        this.onClickTopBackButton();
      }

      if (this.$helpers.isDisplayFormError(code)) {
        this.errors = data.errors;
        return this.$nextTick(() => {
          this.scrollIntoError();
        });
      } else if (this.$helpers.isDisplayErrorInLocalComponent(code)) {
        if (data.approved_input) {
          return this.alertApprovedWastesOrServices(data.message)
        }
        return this.errorToast(data.message);
      }
    },
    async deleteWasteOrServiceByInput (wasteOrServiceByDailyReport) {
      const id = [
        this.dailyReport.schedule_id,
        wasteOrServiceByDailyReport?.daily_report_sub_id,
      ].filter(x => !!x).join('-');
      this.confirm(
        '受付番号'+id+'の作業を削除してもよろしいですか。',
        '（他の枝番は一時保存されます）',
        ''
      ).then(async (result) => {
        if (!result.isConfirmed) return;
        // 一時保存した後に削除する
        const {inputStatus, inputData, inputCode} = await this.preSave();       
        // 一時保存で入力エラーや何かしらエラーがあった場合処理中断する
        if(!inputStatus){
          if (this.$helpers.isDisplayFormError(inputCode)) {
            
            let key = Object.keys(inputData.errors)[0];
            let strA = key.substring(key.indexOf(".")+1);
            let reportIndex = strA.substring(0, strA.indexOf("."));
            this.currentIndex = reportIndex;

            this.errors = inputData.errors;
            return this.$nextTick(() => {
              this.scrollIntoError();
            });
          } else if (this.$helpers.isDisplayErrorInLocalComponent(inputCode)) {
            return this.errorToast(inputData.message);
          }
        }

        const url = apiEndpoints.delete_by_input_page_waste_or_service_by_daily_report(wasteOrServiceByDailyReport.id);

        const {status, data, code} = await this.$http.post(url, {});
        if (status) {
          window.location.reload();
        }

        if (this.$helpers.isDisplayFormError(code)) {
          this.errors = data.errors;
          return this.$nextTick(() => {
            this.scrollIntoError();
          });
        } else if (this.$helpers.isDisplayErrorInLocalComponent(code)) {
          return this.errorToast(data.message);
        }
      });
    },
    async preSave(){
      const {status, data, code} = await this.submitInput(true, true);
      return {inputStatus: status, inputData: data, inputCode: code,};
    },

    onClickTopBackButton() {
      if (this.isInputPage) {
        return this.backByInputPage();
      }
      if (this.isApproveMaintenancePage) {
        return this.backByApproveMaintenancePage();
      }
      if (this.isCreateMaintenancePage) {
        return this.backByCreateMaintenancePage();
      }
      if (this.isApprovePage) {
        return this.backByApprovePage();
      }
    },
    hiddenCancel(){
      return this.wastesOrServicesByDailyReport.find(item => item.transport_approved_status === "1" || item.treatment_approved_status === "1");
    },
    getTargetWasteOrServiceFromJson(targetId){
      return this.dailyReport.work_order_json.waste_or_service_by_work_order.find((item) => item.id == targetId);
    }
  },
  computed: {
    index() {
      return this.$route.query.index || 0;
    },
    wasteOrServiceIds() {
      if (!this.$route.query.waste_or_service_ids) {
        return [];
      }

      return this.$route.query.waste_or_service_ids.toString().split(",").map(x => parseInt(x));
    },
    dailyReportId() {
      return this.$route.params.id;
    },
    vendorSiteId() {
      return this.$route.query.vendor_site_id ?? null;
    },
    zzVendorSiteIndex() {
      return this.vendorSite?.zz_vendor_site_4_id;
    },
    isInputPage() {
      return this.$route.name === "daily_reports.input";
    },
    startEndTimeSchedule() {
      if (!this.dailyReport.schedule) {
        return '';
      }

      const startTimeFormatted = this.$moment(this.dailyReport.schedule.start_datetime).format('HH:mm');
      const endTimeFormatted = this.$moment(this.dailyReport.schedule.end_datetime).format('HH:mm');
      return `${startTimeFormatted} ～ ${endTimeFormatted}`;
    },
    caseId() {
      return this.dailyReport?.work_order_json?.case_id;
    },
    workOrderId() {
      return this.dailyReport?.work_order_json?.id;
    },
    caseDischarger() {
      return this.dailyReport?.work_order_json?.case?.discharger?.name;
    },
    caseDischargerAddress() {
      return [
        this.$helpers.formatZipCode(this.dailyReport?.work_order_json?.case?.discharger?.zip),
        this.dailyReport?.work_order_json?.case?.discharger?.address_1,
        this.dailyReport?.work_order_json?.case?.discharger?.address_2,
        this.dailyReport?.work_order_json?.case?.discharger?.address_3,
        this.dailyReport?.work_order_json?.case?.discharger?.address_4,
      ].filter(x => !!x).join('');
    },
    caseDischargerSite() {
      return this.dailyReport?.work_order_json?.case?.discharger_site?.name;
    },
    caseDischargerSiteAddress() {
      return [
        this.$helpers.formatZipCode(this.dailyReport?.work_order_json?.case?.discharger_site?.zip),
        this.dailyReport?.work_order_json?.case?.discharger_site?.address_1,
        this.dailyReport?.work_order_json?.case?.discharger_site?.address_2,
        this.dailyReport?.work_order_json?.case?.discharger_site?.address_3,
        this.dailyReport?.work_order_json?.case?.discharger_site?.address_4,
      ].filter(x => !!x).join('');
    },
        caseDischargerSitePerson() {
      return this.dailyReport?.work_order_json?.case?.discharger_site?.user1?.user_name;
    },
    workersName() {
      return this.dailyReport?.schedule?.assigned_staffs_by_schedule.map(user => user.user_name).join(', ');
    },
    dynamicIsTreatmentAccepted() {
      if (this.zzVendorSiteIndex) {
        return this.dailyReport[`is_treatment_accepted_${this.zzVendorSiteIndex}`];
      }
      return 0;
    },
    dynamicIsTreatmentComplted() {
      if (this.zzVendorSiteIndex) {
        return this.dailyReport[`is_treatment_completed_${this.zzVendorSiteIndex}`];
      }
      return 0;
    },
    normalServices() {
      return this.wastesOrServicesByDailyReport.filter(x => !x.is_waste)
    },
    wastes() {
      return this.wastesOrServicesByDailyReport.filter(x => !!x.is_waste)
    },
    wastesOrServicesByDailyReportSort() {
      return this.wastes.concat(this.normalServices);
    },
    isWaste() {
      return this.wastesOrServicesByDailyReportSort[this.currentIndex].is_waste;
    },
    isService() {
      return !this.isWaste;
    },
    carsByWorkOrder() {
      if (!this.dailyReport.work_order_json) return [];
      if (!this.dailyReport.work_order_json.car_types_by_work_order) return [];
      let carsByWorkOrder = this.dailyReport.work_order_json.car_types_by_work_order;
      carsByWorkOrder = carsByWorkOrder.map((x, index) => {
        const carByDailyReport = this.dailyReport?.cars_by_daily_report?.find(y => y.id === x.id);
        if (carByDailyReport) {
          carsByWorkOrder[index].number_of_cars = carByDailyReport.pivot.number_of_cars;
        }

        return x;
      })
      return carsByWorkOrder;
    },
    carOptions() {
      if (!this.dailyReport || !this.dailyReport.schedule) {
        return [];
      }

      return this.dailyReport.schedule.assigned_cars_by_schedule.map(assigned_car => {
        assigned_car.display_name = [assigned_car.area_name, assigned_car.classification_number, assigned_car.hiragana, assigned_car.number].filter(x => !!x).join('－');

        return assigned_car;
      });
    },
  },
  watch: {
    vendorSite: {
      handler(newVal) {
        if (!newVal || !newVal.name) return;
        this.getFactoryName(newVal);
      },
      immediate: true,
    },
    'dailyReport.is_schedule_canceled': {
      handler: function (newVal) {
        this.setValueCompleteFields(newVal);
      },
      immediate: true,
    },
    'dailyReport.is_transport_completed': {
      handler: function (newVal) {
        this.disableCancelFields = (newVal === true || newVal === 1) ? true : false;
      },
      immediate: true,
    },
    dynamicIsTreatmentAccepted: {
      handler: function (newVal) {
        this.disableCancelFields = (newVal === true || newVal === 1) ? true : false;
      },
      immediate: true,
    },
    dynamicIsTreatmentComplted: {
      handler: function (newVal) {
        this.disableCancelFields = (newVal === true || newVal === 1) ? true : false;
      },
      immediate: true,
    }
  }
};
</script>
<template>
  <Layout>
    <div class="input-sp-b-row">
      <b-row>
        <b-card>
          <div class="mb-3 align-items-left d-flex gap-2 flex-wrap">
            <div class="d-flex w-100">
              <span class="input-title-sp">作業日報入力</span>
              <span class="input-title-sp" style="margin-left: 20px;">{{ factoryName }}</span>
            </div>
          </div>
          <div class="mb-3">
            <template v-if="index">
              <div class="wrapC">
                <div class="labelC bg-success">No</div>
                <div class="contentC">{{ index }}</div>
              </div>
            </template>
            <div class="wrapC fw-bold">
              <div class="labelC bg-success">作業時間</div>
              <div class="contentC ">
                <span>{{ startEndTimeSchedule }}</span>
              </div>
            </div>
            <div class="wrapC">
              <div class="labelC bg-success">受付番号</div>
              <div class="contentC"><span>{{ dailyReport.schedule_id }}</span></div>
            </div>
            <div class="wrapC">
              <div class="labelC bg-success">作業指示名</div>
              <div class="contentC">
                <router-link
                  v-if="caseId"
                  :to="{ name: 'projects.sales.instructions.detail', params: { id: caseId, work_order_id: workOrderId }, query: { readonly: true, daily_report_id: dailyReport.id } }"
                >
                  {{ dailyReport.work_order_json.name }}
                </router-link>
              </div>
            </div>
            <div class="wrapC">
              <div class="labelC bg-success">排出事業者</div>
              <div class="contentC">
                <span>
                  {{ caseDischarger }}
                </span>
              </div>
            </div>
            <div class="wrapC">
              <div class="labelC bg-success">排出事業者住所</div>
              <div class="contentC">
                <span v-if="caseDischargerAddress">
                  {{ caseDischargerAddress }}
                </span>
              </div>
            </div>
            <div class="wrapC">
              <div class="labelC bg-success">排出事業場</div>
              <div class="contentC">
                <span>
                  {{ caseDischargerSite }}
                </span>
              </div>
            </div>
            <div class="wrapC">
              <div class="labelC bg-success">排出事業場住所</div>
              <div class="contentC">
                <span v-if="caseDischargerSiteAddress">
                  {{ caseDischargerSiteAddress }}
                </span>
              </div>
            </div>
            <div class="wrapC">
              <div class="labelC bg-success">営業担当者</div>
              <div class="contentC">
                <span v-if="caseDischargerSitePerson">
                  {{ caseDischargerSitePerson }}
                </span>
              </div>
            </div>
            <div class="wrapC">
              <div class="labelC bg-success">作業者</div>
              <div class="contentC">
                <span>
                  {{ workersName }}
                </span>
              </div>
            </div>
          </div>
          <!-- For Wastes, Service or Car -->
          <div
            class="input-sp-wastes-or-service-daily-report"
            v-if="wastesOrServicesByDailyReportSort.length != 0"
          >
            <div class="d-flex justify-content">
              <button
                class="btn btn-sm btn-primary w-md-auto waves-effect waves-light"
                @click="previousWaste()"
                v-if="currentIndex > 0"
                style="margin-right: 5px;"
              >
                <i class="far fa-arrow-alt-circle-left"></i> 前へ
              </button>
              <button
                class="btn btn-sm btn-primary w-md-auto waves-effect waves-light"
                @click="nextWaste()"
                v-if="currentIndex < wastesOrServicesByDailyReportSort.length-1"
              >
                次へ <i class="far fa-arrow-alt-circle-right"></i>
              </button>
            </div>
            <template v-if="isWaste">
              <WasteInput
                :can-be-delete="isInputPage && wastesOrServicesByDailyReport.length > 1"
                :control-rules="controlRules"
                :daily-report="dailyReport"
                @openModalSelectWaste="onOpenModalSelectWaste"
                :waste-or-service-by-daily-report="wastesOrServicesByDailyReportSort[currentIndex]"
                :index-waste-or-service="wastesOrServicesByDailyReportSort[currentIndex].origin_index"
                :errors="errors"
                :is-loading="isLoading"
                :car-options="carOptions"
                @deleteWaste="deleteWasteOrServiceByInput"
              ></WasteInput>
            </template>
            <template v-else-if="isService">
              <ServiceInput
                :can-be-delete="isInputPage && wastesOrServicesByDailyReport.length > 1"
                :control-rules="controlRules"
                :daily-report="dailyReport"
                :waste-or-service-by-daily-report="wastesOrServicesByDailyReportSort[currentIndex]"
                :index-waste-or-service="wastesOrServicesByDailyReportSort[currentIndex].origin_index"
                :errors="errors"
                :is-loading="isLoading"
                @deleteService="deleteWasteOrServiceByInput"
              ></ServiceInput>
            </template>
            <template>
              <div class="label-wosdr" style="font-weight: bold;">車両 ：</div>
              <CarInput
                :cars-by-work-order="carsByWorkOrder"
                :control-rules="controlRules"
                :daily-report="dailyReport"
                :errors="errors"
                :is-loading="isLoading"
              ></CarInput>
            </template>
          </div>
          <!-- End -->
          <template v-if="isDisplayControl('daily_reports.remarks')">
            <div class="label-wosdr" style="font-weight: bold;">次回作業者への申し送り事項：</div>
            <div class="label-wosdr">
              <b-form-textarea
                class="w-100"
                id="remarks"
                rows="4"
                max-rows="6"
                v-model="dailyReport.remarks"
              ></b-form-textarea>
            </div>
            <div
              v-if="errors[`dailyReport.remarks`]"
              class="error-message"
            >
              {{ errors[`dailyReport.remarks`][0] }}
            </div>
          </template>
          <template v-if="isDisplayControl('daily_reports.update_request_for_work_order')">
            <div class="label-wosdr" style="font-weight: bold; margin-top: 20px;">事務・営業への申し送り事項：</div>
            <div class="label-wosdr">
              <b-form-textarea
                class="w-100"
                id="update_request_for_work_order"
                rows="4"
                max-rows="6"
                v-model="dailyReport.update_request_for_work_order"
              ></b-form-textarea>
            </div>
            <div
              v-if="errors[`dailyReport.update_request_for_work_order`]"
              class="error-message"
            >
              {{ errors[`dailyReport.update_request_for_work_order`][0] }}
            </div>
          </template>
        </b-card>
      </b-row>
      <WastesAfterTreatment
        @modalHidden="onModalWastesAfterTreatmentHidden"
        @dataSelected="onSelectedWastes"
        ref="wastesAfterTreatmentModal"
      />
    </div>
    <div class="d-flex justify-content-center gap-1" style="margin-top: 20px;">
      <button
        class="btn btn-primary waves-effect waves-light"
        @click="backByInputPage()"
      >
        <i class='far fa-arrow-alt-circle-left'></i> {{ this.$lang.button.back }}
      </button>
      <button
        class="btn btn-primary w-md-auto waves-effect waves-light"
        v-if="isInputPage"
        @click="submitInput(false, true)"
      >
        <i class="fas fa-pencil-alt"></i> {{ this.$lang.button.tempolary }}
      </button>
      <button
        class="w-md-auto waves-effect waves-light"
        :class="dailyReport.is_schedule_canceled ? 'btn btn-outline-primary' : 'btn btn-primary'"
        :disabled="isReadonly('daily_reports.is_schedule_canceled') || disableCancelFields"
        v-if="isDisplayControl('daily_reports.is_schedule_canceled') && !hiddenCancel()"
        @click="onClickScheduleCanceled()"
      >
        <i class="fas fa-times"></i> {{ dailyReport.is_schedule_canceled ? this.$lang.button.discancel : this.$lang.button.cancel }}
      </button>
      <button
        class="w-md-auto waves-effect waves-light btn btn-primary"
        :disabled="isReadonly('daily_reports.is_transport_completed') || disableCompleteFields"
        v-if="isDisplayControl('daily_reports.is_transport_completed') && isInputPage"
        @click="onClickTransportCompleted()"
      >
        運搬完了
      </button>
      <template v-if="vendorSite && zzVendorSiteIndex">
          <button
            v-if="isDisplayControl('daily_reports.is_treatment_completed') && isInputPage"
            class="w-md-auto waves-effect waves-light btn btn-primary"
            :disabled="isReadonly('daily_reports.is_treatment_completed') || disableCompleteFields"
            @click="onClickTreatmentCompleted(zzVendorSiteIndex,dailyReport.work_order_json.zz_work_order_type_id)"
          >
            <template v-if="dailyReport.work_order_json.zz_work_order_type_id === '05' || dailyReport.work_order_json.zz_work_order_type_id === '06'">
              排出完了
            </template>
            <template v-else-if="dailyReport.work_order_json.zz_work_order_type_id === this.$constant.work_order_type.transportation_disposal">
              処分完了
            </template>
            <template v-else>
              搬入・処分完了
            </template>
          </button>
      </template>
    </div>
  </Layout>
</template>
<style lang="scss" scoped>
.input-title-sp {
  font-weight: bold;
}
.input-sp-b-row {
  max-height: calc(100vh - 150px);
  overflow-y: auto;
  overflow-x: hidden;
  .card-body {
    padding: 1.25rem 0.5rem !important;
  }
}
.labelC {
  padding: 10px 7px;
  white-space: nowrap;
  font-weight: bold;
  min-width: 110px;
  border-right: 1px solid #eff2f7;
}
.contentC {
  padding: 7px;
  width: 100%;
}
.wrapC {
  display: flex;
  border-top: 1px solid #eff2f7;
  border-left: 1px solid #eff2f7;
  border-right: 1px solid #eff2f7;
}
.wrapC:last-child {
  border-bottom: 1px solid #eff2f7;
}
.mr-0dot5 {
  margin-right: 5px;
}
.input-sp-wastes-or-service-daily-report {
  margin-bottom: 1rem;
}
.input-sp-checkbox,
.input-sp-switch,
.input-sp-cars {
  margin-bottom: 1rem;
}
.input-sp-group-switch {
  display: flex;
}
.input-sp-switch {
  flex: 1;
}
.btn-outline-primary:hover {
  color: #0576b9;
  background-color: #fff;
  border-color: #0576b9;
}
</style>
